import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../button';
import Typography from '../../typography';
import OtpBoxes from '../../otpBoxes';

export { OtpBoxes };

const StepTwo = ({
  onBack, onConfirm, loading, error,
}) => {
  const [token1, setToken1] = useState('');
  const [token2, setToken2] = useState('');

  const canConfirm = token1.length === 6 && token2.length === 6;

  return (
    <>
      <Typography type="superTitle-italic" text="Confirma la asociación" className="setup2fa__title" />
      <br />
      <Typography
        type="paragraph"
        text="Para vincular tu app necesitamos  dos códigos seguidos. Ingresa el código actual, espera a que cambie (cada 30s) e ingresa el siguiente."
      />
      <br />
      <div className="otp-group">
        <div className="otp-group__label">
          <span className="otp-number">1</span>
          <Typography text="Código actual de tu app" type="field-gray-light" />
        </div>
        <OtpBoxes onChange={setToken1} />
      </div>
      <div className="otp-group">
        <div className="otp-group__label">
          <span className="otp-number">2</span>
          <Typography text="Siguiente código (tras renovarse)" type="field-gray-light" />
        </div>
        <OtpBoxes onChange={setToken2} />
      </div>
      {error && <p className="step-two__error">{error}</p>}
      <div className="step-two__actions">
        <Button
          text="Atrás"
          type="tertiary"
          onClick={onBack}
          className="back-btn"
        />
        <Button
          text="Confirmar y activar"
          type="primary"
          onClick={() => onConfirm(token1, token2)}
          disabled={!canConfirm}
          loading={loading}
        />
      </div>
    </>
  );
};

StepTwo.propTypes = {
  onBack: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

StepTwo.defaultProps = {
  error: null,
};

export default StepTwo;
